import InfoSections from "./InfoSections";

export default InfoSections;
